import { isNullDataPoint } from '@customComp/Chart/chartConfigs/nullHandling/isNullDataPoint';
import { computeAxisPercentPoints } from './computeAxisPercentPoints';
import type { IAxisPercentSeriesItem, TAxisChartSeriesInput } from './types';

function toLinePlottedPercent(oPercent: number): number {
  return Number(Number(oPercent).toFixed(2));
}

/**
 * 折线占比系列：空原始值 → ECharts value null；非空 → 占比数值（供 value 轴与 connectNulls 使用）。
 */
export function buildAxisPercentLineSeries(
  seriesData: TAxisChartSeriesInput[] | undefined,
  xAxisData: string[] | undefined,
): IAxisPercentSeriesItem[] {
  const baseSeries = computeAxisPercentPoints(seriesData, xAxisData);

  return baseSeries.map(seriesItem => ({
    ...seriesItem,
    type: 'line',
    data: seriesItem.data.map(point => ({
      ...point,
      value: isNullDataPoint(point.metricValue)
        ? null
        : toLinePlottedPercent(point.oPercent),
    })),
  }));
}
